import { valueFormat } from '@/pages/intelligence/utils/commonUtils';
import ChartBubble from "@/pages/intelligence/components/ChartBubble";

interface ITooltipFormatterOption {
  isCN: boolean;
  headerLeftTitle?: string;
  headerRightTitle?: string;
  seriesNameFormatter?: (seriesName: string) => string;
}

const tooltipFormatter = (params: any[], option?: ITooltipFormatterOption) => {
  const { isCN, headerLeftTitle, headerRightTitle, seriesNameFormatter } = option || {};
  const { year } = params[0].data;

  return ChartBubble({
    data: params,
    topChartsType: 'global-view-genre-market',
    secondTitleLeft: headerLeftTitle || year || '',
    secondTitleRight: headerRightTitle || 'Revenue',
    serieNameFormatter: seriesNameFormatter,
    isCN,
  })

  // let rowStr = '';
  // for (let i = 0; i < params?.length; i++) {
  //   const t = params?.[i];
  //   const cover = t?.data?.cover;
  //   const name = t?.data?.name;
  //   const nameCN = t?.data?.nameCN;
  //   let seriesName = (isCN ? nameCN : name) || name;
  //   seriesName = seriesNameFormatter?.(seriesName) ?? seriesName;
  //   rowStr += `
  //     <section class="dbi-tooltip-body-item">
  //       <section class="dbi-tooltip-body-item-left">
  //         <i class="dbi-tooltip-body-item-left-dot" style="background-color: ${t?.color};"></i>
  //         ${cover ? `<img class="dbi-tooltip-body-item-left-img" src="${cover}" alt="" />` : ''}
  //         <span class="dbi-tooltip-body-item-left-name">${seriesName || '-'}</span>
  //       </section>
  //       <section class="dbi-tooltip-body-item-right">${valueFormat(t?.value) || '-'}</section>
  //     </section>
  //   `;
  // }
  // const htmlStr = `
  //   <section class="dbi-stack-bar-echarts-tooltip">
  //     <section class="dbi-tooltip-header">
  //       <section class="dbi-tooltip-header-left">${headerLeftTitle || year || ''}</section>
  //       <section class="dbi-tooltip-header-right">${headerRightTitle || 'Revenue'}</section>
  //     </section>
  //     <section class="dbi-tooltip-body">${rowStr}</section>
  //   </section>
  // `;

  // return htmlStr;
};

const buildTooltipFormatter =
  (option?: ITooltipFormatterOption) =>
    (params: any[]): string =>
      tooltipFormatter(params, option);

export { tooltipFormatter, buildTooltipFormatter };
